import { useContext, useEffect, useRef, useState } from "react";

import { Container, Grid, Icon } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Fieldset from "../../../../components/basics/Fieldset";
import { Margin } from "../../../../theme/styles/Utils";
import { ChipTitleStyled } from "../styles/GerenciamentoContrato";
import useGerenciamentoContratoController from "../controllers/GerenciamentoContratoController";
import SearchDialog from "../../../../patterns/modals/SearchDialog";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import { GerenciamentoContratoContext } from "../contexts/GerenciamentoContratoContext";
import { ConfigurationContext } from "../contexts/ConfigurationContext";
import Btn from "../../../../components/buttons/Btn";
import SelectErp from "../../../../components/basics/SelectErp";
import ModalCadastroCliente from "../../../../patterns/modals/modalCadastroCliente/ModalCadastroCliente";
import ModalCadastroDescricao from "../../../../patterns/modals/modalCadastroDescricao/ModalCadastroDescricao";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { GlobalVariables } from "../../../../GlobalVariables";
import { confirmLookupEdit } from "../../../../utils/confirmLookupEdit";
import moment from "moment";
import "moment/locale/pt-br";

const AccordionDadosGerais = ({ location }) => {
  const {
    clientInfos,
    errorsSubmit,
    setClientInfos,
    idContract,
    setIdContract,
    proposedNumber,
    setProposedNumber,
    cpfCnpj,
    setCpfCnpj,
    modality,
    setModality,
    listModality,
    typeService,
    setTypeService,
    listTypeService,
    modelContract,
    setModelContract,
    listModelContract,
    approvalType,
    setApprovalType,
    listApprovalType,
    typeReadjustment,
    setTypeReadjustment,
    listTypeReadjustment,
    dateEmission,
    setDateEmission,
    firstDueDate,
    setFirstDueDate,
    dayDueDate,
    setDayDueDate,
    periodicity,
    setPeriodicity,
    listPeriodicity,
    validity,
    setValidity,
    salesmanInfos,
    setSalesmanInfos,
    regimeCompetency,
    setRegimeCompetency,
    regimeCompetencyList,
    setItemsTable,
    commercialPartnerInfos,
    setCommercialPartnerInfos,
    disabledPaymentOptions,
    leadOrigin,
    setLeadOrigin,
    listLeadOrigin,
    saleType,
    setSaleType,
    listSaleType,
  } = useContext(GerenciamentoContratoContext);

  const { configuration: dadosConfiguration } =
    useContext(ConfigurationContext);

  const { queryParams } = useContext(QueryParamsContext);

  const {
    handleSelectClient,
    handleSelectSalesman,
    handleSelectCommercialPartner,
    handleFirstDueDate,
    handleDayDueDate,
    handleLeadOriginSaved,
    handleSaleTypeSaved,
    storeLeadOrigin,
    updateLeadOrigin,
    storeSaleType,
    updateSaleType,
  } = useGerenciamentoContratoController();

  const [modalClientOpen, setModalClientOpen] = useState(false);
  const [modalCadastroClientOpen, setModalCadastroClientOpen] = useState(false);
  const [modalSalesmanOpen, setModalSalesmanOpen] = useState(false);
  const [modalCommercialPartner, setModalCommercialPartner] = useState(false);
  const [modalLeadOriginOpen, setModalLeadOriginOpen] = useState(false);
  const [modalSaleTypeOpen, setModalSaleTypeOpen] = useState(false);
  const [leadOriginEditItem, setLeadOriginEditItem] = useState(null);
  const [saleTypeEditItem, setSaleTypeEditItem] = useState(null);
  const proposedRef = useRef(null);

  const columnsClientModal = [
    { label: "CPF/CNPJ", id: "cpfcnpj" },
    { label: "Nome", id: "razao" },
  ];
  const columnsSalesmanModal = [
    { label: "CPF/CNPJ", id: "cpfcnpj" },
    { label: "Nome", id: "nomevendedor" },
    { label: "Apelido", id: "apelido" },
  ];
  const columnsCommercialPartner = [
    { label: "CPF/CNPJ", id: "cpfcnpj" },
    { label: "Nome", id: "nome" },
  ];
  const [disabledAccordingModality, setDisabledAccordingModality] =
    useState(false);

  useEffect(() => {
    const disabledAccordingModalityCondition =
      modality?.value === GlobalVariables.contract.modality.separate;
    let period = null;
    let defaultFirstDueDate = null;
    let defaultDayDueDate = null;

    if (!disabledAccordingModalityCondition) {
      const defaultDueDate = moment().add(1, "month");
      defaultFirstDueDate = defaultDueDate.format("YYYY-MM-DD");
      defaultDayDueDate = defaultDueDate.format("D");
      period = {
        value: "1",
        label: "Mensal",
      };
    }

    setFirstDueDate(defaultFirstDueDate);
    setDayDueDate(defaultDayDueDate);
    setPeriodicity(period);
    setDisabledAccordingModality(disabledAccordingModalityCondition);
    setItemsTable([]);
  }, [
    modality,
    setDisabledAccordingModality,
    setFirstDueDate,
    setDayDueDate,
    setPeriodicity,
    setItemsTable,
  ]);

  const useCommercialPartner = queryParams.utilizaparceirocomercial === "SIM";

  return (
    <>
      {modalClientOpen && (
        <SearchDialog
          open={modalClientOpen}
          setOpen={setModalClientOpen}
          columns={columnsClientModal}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectClient}
          route="prouser/clientes/v1"
          title="CLIENTES"
          where={{ ativo: "S" }}
        />
      )}
      {modalCadastroClientOpen && (
        <ModalCadastroCliente
          open={modalCadastroClientOpen}
          setOpen={setModalCadastroClientOpen}
          functionHandleSelectClient={handleSelectClient}
        />
      )}
      {modalSalesmanOpen && (
        <SearchDialog
          open={modalSalesmanOpen}
          setOpen={setModalSalesmanOpen}
          columns={columnsSalesmanModal}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectSalesman}
          route="vendas/vendedores/v1"
          title="VENDEDORES"
          where={{ ativo: "S" }}
        />
      )}
      {modalCommercialPartner && (
        <SearchDialog
          open={modalCommercialPartner}
          setOpen={setModalCommercialPartner}
          columns={columnsCommercialPartner}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectCommercialPartner}
          route="prouser/parceiroscomerciais/v1"
          title="PARCEIROS COMERCIAIS"
          where={{ ativo: "S" }}
        />
      )}
      {modalLeadOriginOpen && (
        <ModalCadastroDescricao
          open={modalLeadOriginOpen}
          setOpen={setModalLeadOriginOpen}
          title='Origem do Lead'
          editItem={leadOriginEditItem}
          onStore={storeLeadOrigin}
          onUpdate={updateLeadOrigin}
          onSaved={handleLeadOriginSaved}
        />
      )}
      {modalSaleTypeOpen && (
        <ModalCadastroDescricao
          open={modalSaleTypeOpen}
          setOpen={setModalSaleTypeOpen}
          title='Tipo da Venda'
          editItem={saleTypeEditItem}
          onStore={storeSaleType}
          onUpdate={updateSaleType}
          onSaved={handleSaleTypeSaved}
        />
      )}

      <Margin top={100}>
        <Container maxWidth="xl">
          <Fieldset
            titulo={
              <Grid item xs={12}>
                <ChipTitleStyled
                  label="DADOS GERAIS DO CONTRATO"
                  bgcolor="tertiary"
                  textcolor="white"
                />
              </Grid>
            }
            bgcolor="white"
            textcolor="black"
            accordion
            defaultExpanded
          >
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <SearchSelect
                  getOptionLabel={(option) =>
                    `${option.cpfcnpj} - ${option.razao}`
                  }
                  label="Cliente"
                  value={clientInfos}
                  setValue={setClientInfos}
                  route="prouser/clientes/v1"
                  filter="razao,apelido"
                  where={{ ativo: "S" }}
                  variant="filled"
                  onChange={(value) => {
                    setClientInfos(value);
                    setCpfCnpj(value?.cpfcnpj);
                  }}
                  customChange
                  error={errorsSubmit?.clientInfos ? true : false}
                  disabled={!!location?.state?.id}
                />
              </Grid>
              <Grid item xs={1}>
                <Btn
                  startIcon={<Icon>search</Icon>}
                  full="true"
                  onClick={() => setModalClientOpen(true)}
                  bgcolor="tertiary"
                  disabled={!!location?.state?.id}
                />
              </Grid>
              <Grid item xs={1}>
                <Btn
                  startIcon={<Icon>add</Icon>}
                  endIcon={<AccountCircleIcon />}
                  full="true"
                  onClick={() => setModalCadastroClientOpen(true)}
                  bgcolor="lightgreen"
                  disabled={!!location?.state?.id}
                />
              </Grid>
              <Grid item xs={location?.state?.id ? 2 : 3}>
                <TextFieldErp
                  label="CPF/CNPJ"
                  size="small"
                  value={cpfCnpj}
                  setValue={setCpfCnpj}
                  disabled
                />
              </Grid>
              <Grid item xs={location?.state?.id ? 2 : 3}>
                <TextFieldErp
                  label="Nro Proposta"
                  size="small"
                  value={proposedNumber}
                  setValue={setProposedNumber}
                  InputProps={{ ref: proposedRef }}
                  maxLength={20}
                  disabled={location?.state?.status === "C"}
                />
              </Grid>
              {location?.state?.id && (
                <Grid item xs={2}>
                  <TextFieldErp
                    label="ID Contrato"
                    size="small"
                    value={idContract}
                    setValue={setIdContract}
                    variant="filled"
                    disabled
                  />
                </Grid>
              )}
              <Grid item xs={2}>
                <SelectErp
                  label="Modalidade"
                  value={modality}
                  setValue={setModality}
                  optionsList={listModality}
                  descriptionField="label"
                  error={errorsSubmit?.modality ? true : false}
                  disabled={!!location?.state?.id}
                />
              </Grid>
              {dadosConfiguration?.utiliza_nova_nfse !== 1 && (
                <Grid item xs={4}>
                  <SelectErp
                    label="Tipo de Serviço"
                    value={typeService}
                    setValue={setTypeService}
                    optionsList={listTypeService}
                    descriptionField="label"
                    error={errorsSubmit?.typeService ? true : false}
                  />
                </Grid>
              )}
              <Grid item xs={2}>
                <SelectErp
                  label="Modelo do Contrato"
                  value={modelContract}
                  setValue={setModelContract}
                  optionsList={listModelContract}
                  descriptionField="label"
                  error={errorsSubmit?.modelContract ? true : false}
                />
              </Grid>
              <Grid item xs={2}>
                <SelectErp
                  label="Tipo Aprovação"
                  value={approvalType}
                  setValue={setApprovalType}
                  optionsList={listApprovalType}
                  descriptionField="label"
                  error={errorsSubmit?.approvalType ? true : false}
                />
              </Grid>
              {modality?.value ===
                GlobalVariables.contract.modality.recurring && (
                <Grid item xs={2}>
                  <SelectErp
                    label="Tipo Reajuste"
                    value={typeReadjustment}
                    setValue={setTypeReadjustment}
                    optionsList={listTypeReadjustment}
                    descriptionField="label"
                    error={errorsSubmit?.typeReadjustment ? true : false}
                  />
                </Grid>
              )}
              <Grid item xs={3}>
                <TextFieldErp
                  label="Dt. Emissão"
                  type="date"
                  value={dateEmission}
                  setValue={setDateEmission}
                  size="small"
                  error={errorsSubmit?.dateEmission ? true : false}
                  disabled={location?.state?.id && disabledPaymentOptions}
                />
              </Grid>
              {modality?.value ===
                GlobalVariables.contract.modality.recurring && (
                <>
                  <Grid item xs={2}>
                    <TextFieldErp
                      label="1° Venc."
                      type="date"
                      value={firstDueDate}
                      setValue={setFirstDueDate}
                      onBlur={handleFirstDueDate}
                      size="small"
                      error={errorsSubmit?.firstDueDate ? true : false}
                      disabled={!!location?.state?.id}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextFieldErp
                      label="Dia Venc. Recorrente"
                      type="number"
                      mask="integer"
                      size="small"
                      value={dayDueDate}
                      setValue={setDayDueDate}
                      onChange={handleDayDueDate}
                      descriptionField="label"
                      maxLength={2}
                      error={errorsSubmit?.dayDueDate ? true : false}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={3}>
                <SelectErp
                  label="Periodicidade (meses)"
                  value={periodicity}
                  setValue={setPeriodicity}
                  optionsList={listPeriodicity}
                  descriptionField="label"
                  disabled={disabledAccordingModality || !!location?.state?.id}
                  error={errorsSubmit?.periodicity ? true : false}
                />
              </Grid>
              <Grid item xs={2}>
                <TextFieldErp
                  label="Vigência"
                  value={validity}
                  setValue={setValidity}
                  placeholder="MM/AAAA"
                  mask="month-and-year"
                  error={errorsSubmit?.validity ? true : false}
                  disabled={location?.state?.id ? true : false}
                />
              </Grid>
              <Grid item xs={useCommercialPartner ? 4 : 6}>
                <SelectErp
                  label="Regime de competência"
                  value={regimeCompetency}
                  setValue={setRegimeCompetency}
                  optionsList={regimeCompetencyList}
                  descriptionField="label"
                  error={errorsSubmit?.regimeCompetency ? true : false}
                />
              </Grid>
              <Grid item xs={useCommercialPartner ? 3 : 5}>
                <SearchSelect
                  descriptionField="apelido"
                  label="Vendedor"
                  value={salesmanInfos}
                  setValue={setSalesmanInfos}
                  route="vendas/vendedores/v1"
                  filter="nomevendedor,apelido"
                  where={{ ativo: "S" }}
                  variant="filled"
                  error={errorsSubmit?.salesmanInfos ? true : false}
                />
              </Grid>
              <Grid item xs={1}>
                <Btn
                  startIcon={<Icon>search</Icon>}
                  full="true"
                  onClick={() => setModalSalesmanOpen(true)}
                  bgcolor="tertiary"
                />
              </Grid>
              {useCommercialPartner && (
                <>
                  <Grid item xs={3}>
                    <SearchSelect
                      descriptionField="nome"
                      label="Parceiro Comercial"
                      value={commercialPartnerInfos}
                      setValue={setCommercialPartnerInfos}
                      route="prouser/parceiroscomerciais/v1"
                      filter="nome,cpfcnpj"
                      where={{ ativo: "S" }}
                      variant="filled"
                      error={!!errorsSubmit?.commercialPartnerInfos}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Btn
                      startIcon={<Icon>search</Icon>}
                      full="true"
                      onClick={() => setModalCommercialPartner(true)}
                      bgcolor="tertiary"
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} md={6}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item xs={10}>
                    <SelectErp
                      label="Origem do Lead"
                      value={leadOrigin}
                      setValue={setLeadOrigin}
                      optionsList={listLeadOrigin}
                      descriptionField="label"
                      variant="filled"
                      getOptionSelected={(option, selected) =>
                        option?.value === selected?.value
                      }
                      disabled={location?.state?.status === "C"}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Btn
                      startIcon={<Icon>add</Icon>}
                      full="true"
                      onClick={() => {
                        setLeadOriginEditItem(null);
                        setModalLeadOriginOpen(true);
                      }}
                      bgcolor="lightgreen"
                      disabled={location?.state?.status === "C"}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Btn
                      startIcon={<Icon>edit</Icon>}
                      full="true"
                      onClick={async () => {
                        if (!leadOrigin?.value) return;

                        const confirmed = await confirmLookupEdit(
                          leadOrigin.label
                        );
                        if (!confirmed) return;

                        setLeadOriginEditItem(leadOrigin);
                        setModalLeadOriginOpen(true);
                      }}
                      bgcolor="tertiary"
                      disabled={
                        !leadOrigin?.value || location?.state?.status === "C"
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item xs={10}>
                    <SelectErp
                      label="Tipo da Venda"
                      value={saleType}
                      setValue={setSaleType}
                      optionsList={listSaleType}
                      descriptionField="label"
                      variant="filled"
                      getOptionSelected={(option, selected) =>
                        option?.value === selected?.value
                      }
                      disabled={location?.state?.status === "C"}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Btn
                      startIcon={<Icon>add</Icon>}
                      full="true"
                      onClick={() => {
                        setSaleTypeEditItem(null);
                        setModalSaleTypeOpen(true);
                      }}
                      bgcolor="lightgreen"
                      disabled={location?.state?.status === "C"}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Btn
                      startIcon={<Icon>edit</Icon>}
                      full="true"
                      onClick={async () => {
                        if (!saleType?.value) return;

                        const confirmed = await confirmLookupEdit(
                          saleType.label
                        );
                        if (!confirmed) return;

                        setSaleTypeEditItem(saleType);
                        setModalSaleTypeOpen(true);
                      }}
                      bgcolor="tertiary"
                      disabled={
                        !saleType?.value || location?.state?.status === "C"
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Fieldset>
        </Container>
      </Margin>
    </>
  );
};

export default AccordionDadosGerais;
